import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '🔴',
  title: 'Tomo 1 — Entender lo que sentís',
  subtitle: 'De la confusión a la claridad emocional',
  accent: 'border-l-red-500',
  items: ['Identificación emocional real', 'Diferenciar emoción vs pensamiento', 'Entender lo que te pasa sin confundirte', 'Base del auto-coaching emocional', 'Primer paso para cambiar']
}, {
  icon: '🟠',
  title: 'Tomo 2 — Detectar patrones',
  subtitle: 'De reaccionar en automático a darte cuenta',
  accent: 'border-l-orange-500',
  items: ['Identificación de patrones emocionales', 'Gatillos emocionales', 'Repetición de conductas', 'Cómo cortar ciclos', 'Observación consciente']
}, {
  icon: '🟡',
  title: 'Tomo 3 — Reprogramar respuestas',
  subtitle: 'De reaccionar mal a elegir cómo actuar',
  accent: 'border-l-yellow-500',
  items: ['Cambio de respuesta emocional', 'Toma de decisiones consciente', 'Control de impulsos', 'Elección de conducta', 'Reacción vs respuesta']
}, {
  icon: '🟢',
  title: 'Tomo 4 — Regular emociones',
  subtitle: 'Cómo bajar intensidad y recuperar control',
  accent: 'border-l-green-500',
  items: ['Regulación emocional práctica', 'Manejo de ansiedad y estrés', 'Técnicas de control inmediato', 'Equilibrio emocional', 'Gestión en situaciones reales']
}, {
  icon: '🔵',
  title: 'Tomo 5 — Comunicar sin reaccionar',
  subtitle: 'Expresarte con claridad sin explotar',
  accent: 'border-l-blue-500',
  items: ['Comunicación emocional efectiva', 'Manejo de conflictos', 'Expresión sin agresividad', 'Límites claros', 'Conversaciones difíciles']
}, {
  icon: '🟣',
  title: 'Tomo 6 — Autonomía emocional',
  subtitle: 'De depender emocionalmente a tener control',
  accent: 'border-l-purple-500',
  items: ['Independencia emocional', 'Seguridad interna', 'Toma de decisiones sólida', 'Claridad personal', 'Dominio emocional']
}];
const features = ['Guías paso a paso', 'Herramientas prácticas', 'Ejemplos reales', 'Aplicación inmediata', 'Uso en el día a día'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-291">
      <div className="max-w-xl mx-auto" data-id="element-292">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-3" data-id="element-293">
          📚 LO QUE RECIBÍS
        </h2>
        <p className="text-center text-gray-400 text-sm mb-8" data-id="element-294">
          6 tomos completos listos para usar
        </p>

        <div className="space-y-3 mb-10" data-id="element-295">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-gray-900 border border-gray-800 border-l-4 ${tomo.accent} rounded-lg overflow-hidden`} data-id="element-296">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-4 flex items-start gap-3 text-left" data-id="element-297">
                  <span className="text-2xl flex-shrink-0" data-id="element-298">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-299">
                    <h3 className="text-sm font-bold text-white mb-0.5" data-id="element-300">
                      {tomo.title}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-301">{tomo.subtitle}</p>
                  </div>
                  {isOpen ? <ChevronUp size={18} className="text-brand-yellow flex-shrink-0 mt-1" data-id="element-302" /> : <ChevronDown size={18} className="text-gray-600 flex-shrink-0 mt-1" data-id="element-303" />}
                </button>
                {isOpen && <div className="px-4 pb-4 pl-12" data-id="element-304">
                    <div className="space-y-2" data-id="element-305">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-306">
                          <CheckCircle2 className="text-green-500 flex-shrink-0" size={14} data-id="element-307" />
                          <span className="text-xs text-gray-400" data-id="element-308">{item}</span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mb-10" data-id="element-309">
          <h3 className="text-base font-bold text-center text-brand-yellow mb-4" data-id="element-310">
            ✨ Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-311">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-312">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={18} data-id="element-313" />
                <span className="text-sm text-gray-300 font-medium" data-id="element-314">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}